export default __webpack_public_path__ + "static/media/derivatives_db_icon.b42ed43d.svg";